exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-geo-data .Select-menu-outer {\n  z-index: 999 !important; }\n\n.modal-geo-data .is-open {\n  position: relative;\n  z-index: 1000; }\n\n.modal-geo-data .control-btn-region {\n  display: flex;\n  justify-content: left;\n  margin: 5px 0; }\n  .modal-geo-data .control-btn-region .btn-add-region button {\n    margin-left: 5px;\n    padding: 7px 25px;\n    border-radius: 20px;\n    cursor: pointer;\n    border: 1px solid #3E60F9;\n    outline: none;\n    color: #000; }\n  .modal-geo-data .control-btn-region .btn-dell-region button {\n    margin-left: 15px;\n    padding: 7px 25px;\n    border-radius: 20px;\n    cursor: pointer;\n    border: 1px solid #3E60F9;\n    outline: none;\n    color: #000; }\n\n.modal-geo-data .main-button {\n  margin: 0 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/containers/CreateCampaign/components/CreateCampaignForm/components/ModalGeoData/ModalGeoData.scss
// module id = 1271
// module chunks = 0